import { animate, scroll, type DOMKeyframesDefinition } from "motion";

const createAnimation = (
  el: HTMLElement,
  target: HTMLElement,
  kfs: DOMKeyframesDefinition,
) => {
  return scroll(
    animate(el, kfs, {
      ease: [0.33, 1, 0.68, 1],
    }),
    {
      target,
      offset: ["start start", "end start"],
    },
  );
};

export { createAnimation };
